<template>
  <div class="ml-2">
    <v-container>
      <h2 class="mb-4">{{ homeCardTitle }}</h2>
      <div class="home-card-content" v-html="safeHomeCardContent" v-if="safeHomeCardContent"></div>
    </v-container>
    <v-carousel v-if="images.length">
      <v-carousel-item v-for="img in images" :key="img.id" :src="img.content">
        <v-container fill-height class="align-end">
          <v-row fill-height class="align-end mb-8">
            <v-col cols="12">
              <v-card color="primary" class="pa-1 text-center">
              <span class="headline white--text">
                <v-icon>mdi-skull</v-icon>
                {{ img.description }}
              </span>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-carousel-item>
    </v-carousel>

  </div>
</template>

<script>
import DataService from "@/services/data.service";

export default {
  name: "Home",
  data() {
    return {
      tab: null,
      images: []
    }
  },
  mounted() {
    DataService.getImages(true).then(data => {
      this.images = data.sort((a, b) => (b.orderNumber ?? 0) - (a.orderNumber ?? 0));
    });
  },
  computed: {
    currentUser() {
      return this.$store.getters["auth/user"];
    },
    appConfig() {
      return this.$store.getters["data/appConfig"];
    },
    appConfigMap() {
      return this.appConfig.reduce((map, entry) => {
        map[entry.key] = entry.value;
        return map;
      }, {});
    },
    homeCardTitle() {
      return this.appConfigMap.HOME_CARD_TITLE || "Willkommen";
    },
    homeCardContent() {
      return this.appConfigMap.HOME_CARD_CONTENT || "";
    },
    safeHomeCardContent() {
      return this.sanitizeHtmlContent(this.homeCardContent);
    },
    hasHomeCardContent() {
      return this.homeCardTitle.trim().length > 0 || this.stripHtml(this.homeCardContent).trim().length > 0;
    }
  },
  methods: {
    stripHtml(value) {
      return (value || "").replace(/<[^>]*>/g, "");
    },
    sanitizeHtmlContent(value) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(value || "", "text/html");

      doc.querySelectorAll("script, style, iframe, object, embed").forEach(node => node.remove());
      doc.querySelectorAll("*").forEach(node => {
        [...node.attributes].forEach(attribute => {
          const attrName = attribute.name.toLowerCase();
          const attrValue = (attribute.value || "").toLowerCase();
          const isInlineEvent = attrName.startsWith("on");
          const isJsUrl = ["href", "src", "xlink:href"].includes(attrName) && attrValue.startsWith("javascript:");

          if (isInlineEvent || isJsUrl) {
            node.removeAttribute(attribute.name);
          }
        });
      });

      return doc.body.innerHTML;
    }
  }
}
</script>


<style scoped>
.home-card-content {
  white-space: normal;
}
</style>
